module.exports = __webpack_public_path__ + "img/Platinum.png";